import { Option } from '@contact/upgrade';

export interface EpticaData {
  pageName: string;
  pageContext: EpticaDataPageContext;
}

export enum EpticaCommentRole {
  AGENT,
  SUPERVISOR,
}

export interface EpticaComment {
  author: string;
  dateTime: Date;
  text: string;
  authorRole: EpticaCommentRole;
}

export interface EpticaDataPageContext {
  account: string | undefined;
  request: Option<EpticaDataRequest>;
  requests: EpticaDataRequest[];
}

export interface EpticaDataRequest {
  id: number;
  accountResponsible: string | undefined;
  customer: Option<EpticaDataCustomer>;
  lastContact: Option<string>;
}

export interface EpticaDataCustomer {
  email: Option<string>;
}

export enum EpticaButtonTypes {
  PJ = 'PJ',
  CHANGE_RECIPIENT = 'CHANGE_RECIPIENT',
  REPLY_ALL = 'REPLY_ALL',
  CLEAR_DRAFT = 'CLEAR_DRAFT',
  PREVIEW = 'PREVIEW',
  PRINT = 'PRINT',
}

export interface EpticaButtonActionTypes {
  id: EpticaButtonTypes;
  hasPermission: boolean;
  label: string;
  label_a11y: string;
  title: string;
  class: string;
  callBack: any;
  disabled: boolean;
  children: EpticaButtonActionTypes[];
}

export enum EpticaDropZoneElements {
  ANSWER_REQUEST = '#formAnswerRequest.dropzone',
  CREATE_REQUEST = '#createRequest.dropzone',
  DELEGATE_REQUEST = '#delegateRequest.dropzone',
  CREATE_DELEGATE = '#createDelegate.dropzone',
  CREATE_ASK_FOR_HELP_REQUEST = '#createAskForHelp.dropzone',
  ANSWER_ASK_FOR_HELP_REQUEST = '#answerAskForHelp.dropzone',
}
